import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#ff6b35] text-white hover:bg-[#e55a2b] focus-visible:ring-[#ff6b35]',
    secondary: 'bg-[#17a2b8] text-white hover:bg-[#138496] focus-visible:ring-[#17a2b8]',
    outline: 'border-2 border-[#17a2b8] text-[#17a2b8] hover:bg-[#17a2b8]/5',
    ghost: 'text-[#17a2b8] hover:bg-[#17a2b8]/10'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-11 px-6 text-base',
    lg: 'h-14 px-8 text-lg'
  };
  return <motion.button whileHover={{
    scale: disabled || isLoading ? 1 : 1.02
  }} whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-160" data-mp="tn6wnnqo98re">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-161" data-mp="xnz54erpz9mm" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-162" data-mp="1ccd9wv8p585t">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-163" data-mp="17fd0qbgjvpah">{rightIcon}</span>}
    </motion.button>;
}